<script setup lang="ts">
import { ContentTypes } from '@ilteducation/components';
import { configHelper } from '@ilteducation/config';
import { useDisplay } from 'vuetify';
import { useFavourites } from '@ilteducation/content-collections';
import { computed, ref } from 'vue';
import type { BookV1 } from '@ilteducation/content-registry-types';
import { useLocale } from '@/plugins/translation';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps<{
  book: BookV1;
}>();

const { toggle, isLoading, hasContent } = useFavourites(ref({ context: 'dyslexia' }));
const isFavourite = computed(() =>
  !isLoading.value ? hasContent.value({ type: ContentTypes.Book, id: props.book.id! }) : undefined,
);

const audioAidUrl = configHelper.getAppUrl('inlasta', 'ilteducation.se');
const { smAndDown } = useDisplay();
const { t, l } = useLocale();
</script>

<template>
  <v-btn-group
    :density="smAndDown ? 'comfortable' : 'default'"
    :class="{ 'd-flex align-self-center': smAndDown }"
    color="transparent"
    class="mt-2 justify-center overflow-visible"
    :rounded="0"
  >
    <v-btn
      size="48"
      variant="text"
      :color="isFavourite ? 'red' : 'black'"
      @click.stop="toggle({ type: ContentTypes.Book, id: props.book.id })"
      :aria-label="t(l.library.button_favourite)"
    >
      <FontAwesomeIcon
        :icon="`${isFavourite ? 'fa-solid' : 'fa-regular'} fa-heart`"
        :size="smAndDown ? undefined : 'lg'"
      />
    </v-btn>
    <v-btn
      size="48"
      target="_blank"
      :href="`${audioAidUrl}/books/${props.book.id}/share?reauthenticate=auto`"
      :aria-label="t(l.library.button_share)"
    >
      <FontAwesomeIcon icon="fa-regular fa-share-from-square" :size="smAndDown ? undefined : 'lg'"></FontAwesomeIcon>
    </v-btn>
    <v-btn
      size="48"
      target="_blank"
      :href="`${audioAidUrl}/books/${props.book.id}?reauthenticate=auto&add-to-collection`"
      :aria-label="t(l.library.button_add_to_collection)"
    >
      <FontAwesomeIcon icon="fa-regular fa-plus" :size="smAndDown ? undefined : 'lg'"></FontAwesomeIcon>
    </v-btn>
    <v-btn
      size="48"
      target="_blank"
      :href="`${audioAidUrl}/books/${props.book.id}?reauthenticate=auto`"
      :aria-label="t(l.library.button_go_to_details)"
    >
      <FontAwesomeIcon icon="fa-regular fa-circle-info" :size="smAndDown ? undefined : 'lg'"></FontAwesomeIcon>
    </v-btn>
  </v-btn-group>
</template>

<style scoped lang="scss"></style>
